<div class="view">

    <div class="view__content"></div>

    <div class="view__close ui__button">
        &times;
    </div>

</div>